import { Component } from '@angular/core';

@Component({
  selector: 'kui-accordion',
  templateUrl: './accordion.component.html',
})
export class KuiAccordionComponent { }
